export enum NotificationType {
  ALL = 'all',
  FAILED_STAGES = 'failed_stages',
  CUSTOM = 'custom'
}

export enum NotificationStage {
  SW_DISTRIBUTION = 'sw_distribution',
  OCI_REGISTRY = 'oci_registry',
  ARTIFACTS_RETRIEVING_LAB = 'artifacts_retrieving_lab',
  ARTIFACTS_ONBOARDING_LAB = 'artifacts_onboarding_lab',
  ARTIFACTS_DEPLOYMENT = 'artifacts_deployment',
  TESTING = 'testing',
  ARTIFACTS_RETRIEVING_PROD = 'artifacts_retrieving_prod',
  ARTIFACTS_ONBOARDING_PROD = 'artifacts_onboarding_prod'
}
